
import { gsap } from 'gsap';
export default class ScrollIndicator {
    constructor() {

        this.init();

    }
    init() {
        gsap.to('.scroll-indicator svg .text-group', { rotation: -360, duration: 8, repeat: -1, transformOrigin: '50% 50%', ease: 'none' });
        gsap.fromTo('.scroll-indicator svg .circle', { scale: 0.75, transformOrigin: '50% 50%' }, { scale: 1.05, duration: 1, stagger: { each: 0.2 }, repeat: -1, yoyo: true, transformOrigin: '50% 50%', ease: 'power1.inOut' });
    }
}